import {avatar, Avatar, btn, cards, comp, Component, Config, fieldset, h3, p, router, tbar} from "@intermesh/goui";
import {CurrentSection} from "./services/CurrentSection.js";
import {ServerApi} from "./util/ServerApi.js";
import {t} from "./util/Translate.js";
export class SectionSelect extends Component {

	private selections: Component;

	constructor() {
		super("section");
		this.itemId = "section-select";
		this.id = "section-select";
		this.cls = "ifw-card";

		this.title = t("Please choose");

		this.items.add(
			comp({},
				cards({
						activeItem: 0
					}, fieldset(
						{},
						comp(
							{
								tagName: "div",
								cls: "ifw-title-cnt"
							}, h3({
								cls: "ifw-title",
								text: this.title
							})),
						this.selections = comp({
							cls: "hbox",
							style: {
								flexWrap: "wrap",
								justifyContent: "space-evenly"
							}
						}),
					),
				)
			),
			tbar({
					cls: "ifw-bbar"
				},
				btn({
					text: t("Back"),
					route: "register"
				}),
				'->'
			)
		);

		const url = ServerApi.url("elearning/frontend/sections", {
			returnProperties: '*,languages[*,language]'
		});
		ServerApi.call(url, {}, "GET").then((result) => {
			for (const res of result.data) {
				let avaConfig = {
					title: res.name,
					height: 100,
					width: 100,
					cls: "goui-avatar centered",
				} as  Config<Avatar>;
				if (res.image) {
					avaConfig.backgroundImage = ServerApi.thumbUrl(res.image, 100, 100, true);
				} else {
					avaConfig.displayName = res.name;
				}

				this.selections.items.add(
					comp({
							cls: "vbox activities",
							style: {
								cursor: "pointer"
							},
							listeners: {
								added: (cmp) => {
									cmp.el.addEventListener("click", async (_elm) => {

										const cs = await CurrentSection.readIf(res.id);
										const sectionLanguage = cs.languages.find((item: any)=> {
											return item.languageId === parseInt(sessionStorage.getItem("languageId")!);
										})
										if(sectionLanguage.showInfoPage) {
											await router.goto("section-info");
										} else {
											await router.goto("course-selection");
										}
									});
								}
							}
						},
						comp({}, avatar(avaConfig)),
						comp({},
							p({
									text: res.name,
									cls: "course-selection"
								},
							),
						)
					)
				)
			}

		});
	}
}